export default __webpack_public_path__ + "static/Cloud-computing-777fdd32de10b9ec3eaff486af6597f9.webp";